import React, { useEffect } from "react";
import "./SuccessStories.css";
import { SuccessBannerSection } from "./BannerSection";

export const SuccessStories = ({ onLoad }) => {
  useEffect(() => {
    onLoad();
  }, [onLoad]);
  return (
    <div>
      <SuccessBannerSection/>
    </div>
  );
};
